/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Cancel_Schedule_DescInputs */



/**
* | output |
* | --- |
* | "The pending storage change will be canceled and the current bundle kept." |
*
* @param {Partner_Manage_Storage_Cancel_Schedule_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_cancel_schedule_desc = /** @type {((inputs?: Partner_Manage_Storage_Cancel_Schedule_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Cancel_Schedule_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die ausstehende Speicheränderung wird abgebrochen und das aktuelle Paket beibehalten.")
	return /** @type {LocalizedString} */ ("The pending storage change will be canceled and the current bundle kept.")
});